export const ConfirmQtFromAirlineKey = 'CONFIRM_QT_FROM_AIRLINE';
export const EVENT_DATE_FORMAT = 'YYYY-MM-DD HH:mm';
export const ENFORCE_LOCATION_ACCESS_CONTROL = false;
